module.exports = __webpack_public_path__ + "static/media/free-damm-0.dd6d0de8.jpg";